import { Modal } from '@tribeplatform/react-ui-kit/Modal'

import { AuditLogList } from './AuditLogList'

export const AuditLogsModal = ({
  open,
  onClose,
  spaceId,
  actorId,
  postId,
  memberId,
  noun,
  from,
}: {
  open: boolean
  onClose: () => void
  spaceId?: string
  actorId?: string
  postId?: string
  memberId?: string
  noun?: string
  from?: number
}) => {
  return (
    <Modal open={open} onClose={onClose} size="2xl">
      <Modal.Header title="Audit log" />
      <Modal.Content>
        <AuditLogList {...{ spaceId, actorId, postId, memberId, noun, from }} />
      </Modal.Content>
    </Modal>
  )
}
